<template>
  <div>
    <Form ref="cancelInformationform" :model="form" :rules="rules" :label-width="180">
      <Spin size="large" fix v-if="loading"></Spin>
      <Row :gutter="16">
        <Col span="24">
        <FormItem label="注销对象类型" prop="logoutObjectType">
          <RadioGroup v-model="form.logoutObjectType">
            <Radio v-for="select in $store.state.logoutObjectTypeList" :label="select.value" :key="select.value">{{select.text}}</Radio>
          </RadioGroup>
        </FormItem>
        </Col>
        <Col v-if="form.logoutObjectType==$store.state.logoutObjectTypeList.find(el=>{return el.text=='配偶/子女'}).value" span="12">
        <FormItem prop="isLogoutChildren">
          <Checkbox v-model="form.isLogoutChildren" :label="true">子女</Checkbox>
          <Checkbox v-model="form.isLogoutSpouse" :label="true">配偶</Checkbox>
        </FormItem>
        </Col>
      </Row>
      <Divider orientation="left">申请人信息</Divider>
      <Row :gutter="16">
        <Col span="12">
        <FormItem label="上传申请人身份证人像面" prop="applicantIDCardFrontGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <div>
                <Upload type="drag" class="uploadImage" :max-size="5120" :on-exceeded-size="handleMaxSize" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantIDCardFrontGuidProgress')"
                  :show-upload-list="false" :accept="accept" :format="format" :data="{ readIdInfo: true }" :on-success="
                    (response, file, fileList) =>
                     {$refs['applicantIDCardFrontGuidProgress'].updateShow(false)
        $refs['applicantIDCardFrontGuidProgressUpload'].style.display = 'block'; handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantIDCardFrontGuid',false,'idCard',[{name:'applicantName'},{idCard:'applicantIDCardNo'}]
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                  <div class="uploadBg">
                    <span ref="applicantIDCardFrontGuidProgressUpload">
                      <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                      <div class="upload_btn">
                        <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                      </div>
                      <div class="upload_btn" @click.stop="openQrCodeUpload('applicantIDCardFrontGuid',false,'idCard',[{name:'applicantName'},{idCard:'applicantIDCardNo'}])">
                        <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                      </div>
                    </span>
                    <progress-bar ref="applicantIDCardFrontGuidProgress"></progress-bar>
                  </div>
                </Upload>

              </div>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantIDCardFrontGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantIDCardFrontGuid
                      " />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardFrontGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantIDCardFrontGuid,
                            'applicantIDCardFrontGuid'
                          )
                        " type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="上传申请人身份证国徽面" prop="applicantIDCardBackGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" ref="applicantIDCardBackGuid" :data="{readIdbackAfterUploaded: true}" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantIDCardBackGuidProgress')"
                class="uploadImage" :accept="accept" :format="format" :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                     {$refs['applicantIDCardBackGuidProgress'].updateShow(false)
        $refs['applicantIDCardBackGuidProgressUpload'].style.display = 'block'; handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantIDCardBackGuid',false,'idcard_back'
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantIDCardBackGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantIDCardBackGuid',false,'idcard_back')">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantIDCardBackGuidProgress"></progress-bar>
                </div>
              </Upload>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantIDCardBackGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="
                        $baseURL + '/file/cover/' + form.applicantIDCardBackGuid
                      " />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardBackGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantIDCardBackGuid,
                            'applicantIDCardBackGuid'
                          )
                        " type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="申请人姓名" prop="applicantName">
          <Input v-model.trim="form.applicantName" disabled :maxlength="20" placeholder="上传身份证人像面自动识别"></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="申请人身份证号" prop="applicantIDCardNo">
          <Input v-model.trim="form.applicantIDCardNo" disabled :maxlength="20" placeholder="上传身份证人像面自动识别"></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="户籍类型" prop="applicantRegisteredResidenceType">
          <RadioGroup v-model.trim="form.applicantRegisteredResidenceType">
            <Radio :label="value" v-for="{text,value} in $store.state.registeredResidenceTypeList" :key="value">{{text}}</Radio>
          </RadioGroup>
        </FormItem>
        </Col>
        <Col span="24" v-if="form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['集体户口']">
        <FormItem label="集体户口类型" required prop="applicantCollectiveAccountMaterialsType">
          <RadioGroup v-model.trim="form.applicantCollectiveAccountMaterialsType">
            <Radio :label="value" v-for="{text,value} in $store.state.collectiveAccountMaterialsTypeList" :key="value">{{text}}</Radio>
          </RadioGroup>
        </FormItem>
        </Col>
        <template
          v-if="form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.applicantCollectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">
          <Col span="12">
          <FormItem label="上传户口簿详细地址页的首页" prop="applicantResidenceBookletMainPageGuid">
            <Row :gutter="16">
              <Col span="24">
              <div class="line_area">
                <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidenceBookletMainPageGuidProgress')" :accept="accept" :format='format'
                  :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['applicantResidenceBookletMainPageGuidProgress'].updateShow(false)
        $refs['applicantResidenceBookletMainPageGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'applicantResidenceBookletMainPageGuid')}" :on-format-error="handleFormatError"
                  :action="$baseURL+'/common/file/uploadfile'">
                  <div class="uploadBg">
                    <span ref="applicantResidenceBookletMainPageGuidProgressUpload">
                      <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                      <div class="upload_btn">
                        <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                      </div>
                      <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidenceBookletMainPageGuid')">
                        <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                      </div>
                    </span>
                    <progress-bar ref="applicantResidenceBookletMainPageGuidProgress"></progress-bar>

                  </div>
                </Upload>
                <!-- 已上传图片 -->
                <div class="fileList" v-if="form.applicantResidenceBookletMainPageGuid">
                  <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                  <span class="pos">
                    <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantResidenceBookletMainPageGuid" />
                    <i class="img_magnify">
                      <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidenceBookletMainPageGuid)" type="ios-eye" />

                      <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.applicantResidenceBookletMainPageGuid,'applicantResidenceBookletMainPageGuid')" type="ios-trash-outline" />
                    </i>
                  </span>
                  <!-- </template> -->
                </div>
                <div class="fileList" v-else>
                  <span class="pos">
                    <span class="img">
                      <span class="uploadImageNo">
                        <Icon type="ios-image" size="30" />
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              </Col>
            </Row>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="上传户口簿本人信息页" prop="applicantResidenceBookletSelfPageGuid">
            <Row :gutter="16">
              <Col span="24">
              <div class="line_area">
                <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidenceBookletSelfPageGuidProgress')" :accept="accept" :format='format'
                  :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['applicantResidenceBookletSelfPageGuidProgress'].updateShow(false)
        $refs['applicantResidenceBookletSelfPageGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'applicantResidenceBookletSelfPageGuid')}" :on-format-error="handleFormatError"
                  :action="$baseURL+'/common/file/uploadfile'">
                  <div class="uploadBg">
                    <span ref="applicantResidenceBookletSelfPageGuidProgressUpload">
                      <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                      <div class="upload_btn">
                        <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                      </div>
                      <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidenceBookletSelfPageGuid')">
                        <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                      </div>
                    </span>
                    <progress-bar ref="applicantResidenceBookletSelfPageGuidProgress"></progress-bar>

                  </div>
                </Upload>
                <div class="fileList" v-if="form.applicantResidenceBookletSelfPageGuid">
                  <span class="pos">
                    <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantResidenceBookletSelfPageGuid" />
                    <i class="img_magnify">
                      <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidenceBookletSelfPageGuid)" type="ios-eye" />
                      <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.applicantResidenceBookletSelfPageGuid,'applicantResidenceBookletSelfPageGuid')" type="ios-trash-outline" />
                    </i>
                  </span>
                </div>
                <div class="fileList" v-else>
                  <span class="pos">
                    <span class="img">
                      <span class="uploadImageNo">
                        <Icon type="ios-image" size="30" />
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              </Col>
            </Row>
          </FormItem>
          </Col>
        </template>
        <template v-if="form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.applicantCollectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明']">
          <Col span="12">
          <FormItem label="派出所出具的户籍证明" prop="applicantPoliceStationRegistrationCertificateGuid">
            <Row :gutter="16">
              <Col span="24">
              <div class="line_area">
                <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantPoliceStationRegistrationCertificateGuidProgress')" :accept="accept" :format='format'
                  :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['applicantPoliceStationRegistrationCertificateGuidProgress'].updateShow(false)
        $refs['applicantPoliceStationRegistrationCertificateGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'applicantPoliceStationRegistrationCertificateGuid')}" :on-format-error="handleFormatError"
                  :action="$baseURL+'/common/file/uploadfile'">
                  <div class="uploadBg">
                    <span ref="applicantPoliceStationRegistrationCertificateGuidProgressUpload">
                      <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                      <div class="upload_btn">
                        <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                      </div>
                      <div class="upload_btn" @click.stop="openQrCodeUpload('applicantPoliceStationRegistrationCertificateGuid')">
                        <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                      </div>
                    </span>
                    <progress-bar ref="applicantPoliceStationRegistrationCertificateGuidProgress"></progress-bar>

                  </div>
                </Upload>
                <!-- 已上传图片 -->
                <div class="fileList" v-if="form.applicantPoliceStationRegistrationCertificateGuid">
                  <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                  <span class="pos">
                    <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantPoliceStationRegistrationCertificateGuid" />
                    <i class="img_magnify">
                      <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantPoliceStationRegistrationCertificateGuid)" type="ios-eye" />

                      <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.applicantPoliceStationRegistrationCertificateGuid,'applicantPoliceStationRegistrationCertificateGuid')" type="ios-trash-outline" />
                    </i>
                  </span>
                  <!-- </template> -->
                </div>
                <div class="fileList" v-else>
                  <span class="pos">
                    <span class="img">
                      <span class="uploadImageNo">
                        <Icon type="ios-image" size="30" />
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              </Col>
            </Row>
          </FormItem>
          </Col>
        </template>
        <Col span="24">
        <FormItem label="申请人联系方式" prop="applicantPhone">
          <Input v-model.trim="form.applicantPhone" :maxlength="40" type="number" placeholder="请填写"></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="上传申请人居住证正面" prop="applicantResidencePermitFrontGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :max-size="5120" :on-exceeded-size="handleMaxSize" :accept="accept" :format="format" :data="{readResidencePermit:true,}"
                :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidencePermitFrontGuidProgress')" :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                    {  $refs['applicantResidencePermitFrontGuidProgress'].updateShow(false)
        $refs['applicantResidencePermitFrontGuidProgressUpload'].style.display = 'block';handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantResidencePermitFrontGuid',false,'residencePermit',[{residencePermitExpiryDate:'applicantResidencePermitExpiryDate'}]
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantResidencePermitFrontGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidencePermitFrontGuid',false,'residencePermit',[{residencePermitExpiryDate:'applicantResidencePermitExpiryDate'}])">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantResidencePermitFrontGuidProgress"></progress-bar>
                </div>
              </Upload>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantResidencePermitFrontGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantResidencePermitFrontGuid
                      " />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidencePermitFrontGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantResidencePermitFrontGuid,
                            'applicantResidencePermitFrontGuid'
                          )
                        " type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <!-- <Col span="12">
        <FormItem label="上传申请人居住证反面" prop="applicantResidencePermitBackGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :accept="accept" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidencePermitBackGuidProgress')" :format="format"
                :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                      {$refs['applicantResidencePermitBackGuidProgress'].updateShow(false)
        $refs['applicantResidencePermitBackGuidProgressUpload'].style.display = 'block';handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantResidencePermitBackGuid'
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantResidencePermitBackGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidencePermitBackGuid')">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantResidencePermitBackGuidProgress"></progress-bar>
                </div>
              </Upload>
              <div class="fileList" v-if="form.applicantResidencePermitBackGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantResidencePermitBackGuid
                      " />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidencePermitBackGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantResidencePermitBackGuid,
                            'applicantResidencePermitBackGuid'
                          )
                        " type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col> -->
        <Col span="12">
        <FormItem label="居住证有效期" prop="applicantResidencePermitExpiryDate">
          <DatePicker type="date" disabled :editable="false" v-model.trim="form.applicantResidencePermitExpiryDate" placeholder="请选择" style="width: 100%" />
        </FormItem>
        </Col>

      </Row>

      <!--    配偶-->
      <template v-if="form.logoutObjectType==$store.state.logoutObjectTypeList.find(el=>{return el.text=='配偶/子女'}).value&&form.isLogoutSpouse">
        <Divider orientation="left">上传配偶信息</Divider>
        <Row :gutter="16">
          <Col span="12">
          <FormItem label="上传配偶身份证人像面" prop="idCardFrontGuid">
            <Row :gutter="16">
              <Col span="24">
              <div class="line_area">
                <div>
                  <Upload multiple type="drag" class="uploadImage" :max-size="5120" :on-exceeded-size="handleMaxSize" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'idCardFrontGuidProgress')" :accept="accept"
                    :format='format' :show-upload-list='false' :data="{ readIdInfo: true }" :on-success="(response, file, fileList)=>{$refs['idCardFrontGuidProgress'].updateShow(false)
        $refs['idCardFrontGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'idCardFrontGuid',false,'spouseIdCard',[{name:'name',},{idCard:'idCardNo'}])}" :on-format-error="handleFormatError"
                    :action="$baseURL+'/common/file/uploadfile'">
                    <div class="uploadBg">
                      <span ref="idCardFrontGuidProgressUpload">
                        <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                        <div class="upload_btn">
                          <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                        </div>
                        <div class="upload_btn" @click.stop="openQrCodeUpload('idCardFrontGuid',false,'spouseIdCard',[{name:'name',},{idCard:'idCardNo'}])">
                          <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                        </div>
                      </span>
                      <progress-bar ref="idCardFrontGuidProgress"></progress-bar>

                    </div>
                  </Upload>
                </div>
                <!-- 已上传图片 -->
                <div class="fileList" v-if="form.idCardFrontGuid">
                  <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                  <span class="pos">
                    <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.idCardFrontGuid" />
                    <i class="img_magnify">
                      <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.idCardFrontGuid)" type="ios-eye" />
                      <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.idCardFrontGuid,'idCardFrontGuid')" type="ios-trash-outline" />
                    </i>
                  </span>
                  <!-- </template> -->
                </div>
                <div class="fileList" v-else>
                  <span class="pos">
                    <span class="img">
                      <span class="uploadImageNo">
                        <Icon type="ios-image" size="30" />
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              </Col>
            </Row>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="上传配偶身份证国徽面" prop="idCardBackGuid">
            <Row :gutter="16">
              <Col span="24">
              <div class="line_area">
                <Upload multiple type="drag" class="uploadImage" :data="{readIdbackAfterUploaded: true}" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'idCardBackGuidProgress')" :accept="accept"
                  :format='format' :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['idCardBackGuidProgress'].updateShow(false)
        $refs['idCardBackGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'idCardBackGuid',false,'idcard_back')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
                  <div class="uploadBg">
                    <span ref="idCardBackGuidProgressUpload">
                      <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                      <div class="upload_btn">
                        <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                      </div>
                      <div class="upload_btn" @click.stop="openQrCodeUpload('idCardBackGuid',false,'idcard_back')">
                        <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                      </div>
                    </span>
                    <progress-bar ref="idCardBackGuidProgress"></progress-bar>

                  </div>
                </Upload>
                <!-- 已上传图片 -->
                <div class="fileList" v-if="form.idCardBackGuid">
                  <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                  <span class="pos">
                    <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.idCardBackGuid" />
                    <i class="img_magnify">
                      <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.idCardBackGuid)" type="ios-eye" />
                      <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.idCardBackGuid,'idCardBackGuid')" type="ios-trash-outline" />

                    </i>
                  </span>
                  <!-- </template> -->
                </div>
                <div class="fileList" v-else>
                  <span class="pos">
                    <span class="img">
                      <span class="uploadImageNo">
                        <Icon type="ios-image" size="30" />
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              </Col>
            </Row>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="配偶姓名" prop="name">
            <Input v-model.trim="form.name" disabled :maxlength="40" placeholder="上传身份证人像面自动识别"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="配偶身份证号" prop="idCardNo">
            <Input v-model.trim="form.idCardNo" disabled :maxlength="40" placeholder="上传身份证人像面自动识别"></Input>
          </FormItem>
          </Col>

          <Col span="24">
          <FormItem label="配偶户籍" prop="registeredResidenceType">
            <RadioGroup v-model.trim="form.registeredResidenceType">
              <Radio :label="value" v-for="{text,value} in $store.state.registeredResidenceTypeList" :key="value">{{text}}</Radio>
            </RadioGroup>
          </FormItem>
          </Col>
          <Col span="24" v-if="form.registeredResidenceType===$store.state.registeredResidenceType['集体户口']">
          <FormItem label="集体户口类型" prop="collectiveAccountMaterialsType">
            <RadioGroup v-model.trim="form.collectiveAccountMaterialsType">
              <Radio :label="value" v-for="{text,value} in $store.state.collectiveAccountMaterialsTypeList" :key="value">{{text}}</Radio>
            </RadioGroup>
          </FormItem>
          </Col>
          <template
            v-if="form.registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">
            <Col span="12">
            <FormItem label="上传配偶户口簿详细地址页的首页" prop="residenceBookletMainPageGuid">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">
                  <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'residenceBookletMainPageGuidProgress')" :accept="accept" :format='format'
                    :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['residenceBookletMainPageGuidProgress'].updateShow(false)
        $refs['residenceBookletMainPageGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'residenceBookletMainPageGuid')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
                    <div class="uploadBg">
                      <span ref="residenceBookletMainPageGuidProgressUpload">
                        <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                        <div class="upload_btn">
                          <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                        </div>
                        <div class="upload_btn" @click.stop="openQrCodeUpload('residenceBookletMainPageGuid')">
                          <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                        </div>
                      </span>
                      <progress-bar ref="residenceBookletMainPageGuidProgress"></progress-bar>

                    </div>
                  </Upload>
                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="form.residenceBookletMainPageGuid">
                    <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                    <span class="pos">
                      <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.residenceBookletMainPageGuid" />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.residenceBookletMainPageGuid)" type="ios-eye" />

                        <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.residenceBookletMainPageGuid,'residenceBookletMainPageGuid')" type="ios-trash-outline" />
                      </i>
                    </span>
                    <!-- </template> -->
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem label="上传配偶户口簿本人信息页" prop="residenceBookletSelfPageGuid">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">
                  <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'residenceBookletSelfPageGuidProgress')" :accept="accept" :format='format'
                    :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['residenceBookletSelfPageGuidProgress'].updateShow(false)
        $refs['residenceBookletSelfPageGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'residenceBookletSelfPageGuid')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
                    <div class="uploadBg">
                      <span ref="residenceBookletSelfPageGuidProgressUpload">
                        <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                        <div class="upload_btn">
                          <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                        </div>
                        <div class="upload_btn" @click.stop="openQrCodeUpload('residenceBookletSelfPageGuid')">
                          <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                        </div>
                      </span>
                      <progress-bar ref="residenceBookletSelfPageGuidProgress"></progress-bar>

                    </div>
                  </Upload>
                  <div class="fileList" v-if="form.residenceBookletSelfPageGuid">
                    <span class="pos">
                      <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.residenceBookletSelfPageGuid" />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.residenceBookletSelfPageGuid)" type="ios-eye" />
                        <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.residenceBookletSelfPageGuid,'residenceBookletSelfPageGuid')" type="ios-trash-outline" />
                      </i>
                    </span>
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
          </template>
          <template v-if="form.registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明']">
            <Col span="12">
            <FormItem label="派出所出具的户籍证明" prop="policeStationRegistrationCertificateGuid">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">
                  <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'policeStationRegistrationCertificateGuidProgress')" :accept="accept" :format='format'
                    :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['policeStationRegistrationCertificateGuidProgress'].updateShow(false)
        $refs['policeStationRegistrationCertificateGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'policeStationRegistrationCertificateGuid')}" :on-format-error="handleFormatError"
                    :action="$baseURL+'/common/file/uploadfile'">
                    <div class="uploadBg">
                      <span ref="policeStationRegistrationCertificateGuidProgressUpload">
                        <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                        <div class="upload_btn">
                          <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                        </div>
                        <div class="upload_btn" @click.stop="openQrCodeUpload('policeStationRegistrationCertificateGuid')">
                          <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                        </div>
                      </span>
                      <progress-bar ref="policeStationRegistrationCertificateGuidProgress"></progress-bar>

                    </div>
                  </Upload>
                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="form.policeStationRegistrationCertificateGuid">
                    <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                    <span class="pos">
                      <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.policeStationRegistrationCertificateGuid" />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.policeStationRegistrationCertificateGuid)" type="ios-eye" />

                        <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.policeStationRegistrationCertificateGuid,'policeStationRegistrationCertificateGuid')" type="ios-trash-outline" />
                      </i>
                    </span>
                    <!-- </template> -->
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
          </template>

          <Col span="12">
          <FormItem label="上传持证人结婚证原件" prop="marriageCertificateGuid">
            <Row :gutter="16">
              <Col span="24">
              <div class="line_area">
                <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'marriageCertificateGuidProgress')" :accept="accept" :format='format' :show-upload-list='false'
                  :on-success="(response, file, fileList)=>{$refs['marriageCertificateGuidProgress'].updateShow(false)
        $refs['marriageCertificateGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'marriageCertificateGuid')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
                  <div class="uploadBg">
                    <span ref="marriageCertificateGuidProgressUpload">
                      <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                      <div class="upload_btn">
                        <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                      </div>
                      <div class="upload_btn" @click.stop="openQrCodeUpload('marriageCertificateGuid')">
                        <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                      </div>
                    </span>
                    <progress-bar ref="marriageCertificateGuidProgress"></progress-bar>

                  </div>
                </Upload>
                <!-- 已上传图片 -->
                <div class="fileList" v-if="form.marriageCertificateGuid">
                  <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                  <span class="pos">
                    <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.marriageCertificateGuid" />
                    <i class="img_magnify">
                      <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.marriageCertificateGuid)" type="ios-eye" />
                      <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.marriageCertificateGuid,'marriageCertificateGuid')" type="ios-trash-outline" />
                    </i>
                  </span>
                  <!-- </template> -->
                </div>
                <div class="fileList" v-else>
                  <span class="pos">
                    <span class="img">
                      <span class="uploadImageNo">
                        <Icon type="ios-image" size="30" />
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              </Col>
            </Row>
          </FormItem>
          </Col>
        </Row>
      </template>
      <template v-if="form.logoutObjectType==$store.state.logoutObjectTypeList.find(el=>{return el.text=='配偶/子女'}).value&&form.isLogoutChildren">

        <!--      子女-->
        <Divider orientation="left">上传子女信息</Divider>
        <template v-for="(item, index) in form.childrenList">
          <div class="childBox_childPage" :key="index">
            <span class="removeIcon" v-show="form.childrenList.length > 1" @click="delChild('childrenList', index)">
              <Icon type="md-close" size="20" color="#ffffff" />
            </span>
            <Row :gutter="16">
              <Col span="12">
              <FormItem :label="'子女' + (index + 1) + '姓名'" :prop="'childrenList[' + index + '].name'" :rules="{ required: true, message: '请输入', trigger: 'change' }">
                <Input v-model.trim="form.childrenList[index].name" :maxlength="40" placeholder="请输入">
                </Input>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem :label="'子女' + (index + 1) + '身份证号'" :prop="'childrenList[' + index + '].idCardNo'"
                :rules="[{ required: true, message: '请输入', trigger: 'change' },{ pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '请输入正确的身份证号', trigger: 'blur' }]">
                <Input v-model.trim="form.childrenList[index].idCardNo" :maxlength="40" @on-blur="getChildAge('cancelInformationform' ,index)" placeholder="请输入">
                </Input>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem :label="'子女' + (index + 1) + '年龄'" :prop="'childrenList[' + index + '].age'" :rules="{
                required: true,
                type: 'number',
                message: '请输入',
                trigger: 'change',
              }">
                <Input type="number" readonly v-model.trim.number="form.childrenList[index].age" placeholder="根据身份证自动识别">
                </Input>
              </FormItem>
              </Col>
              <Col span="24">
              <FormItem :label="'子女' + (index + 1) + '户籍'" :prop="'childrenList[' + index + '].registeredResidenceType'" :rules="{
                required: true,
                message: '请选择',
                type: 'number',
                trigger: 'change',
              }">
                <RadioGroup v-model.trim="form.childrenList[index].registeredResidenceType">
                  <Radio :label="value" v-for="{text,value} in $store.state.registeredResidenceTypeList" :key="value">{{text}}</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
              <Col span="24" v-show="form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']">
              <FormItem :label="'子女' + (index + 1) + '集体户口类型'" :prop="'childrenList[' + index + '].collectiveAccountMaterialsType'" :rules="{
                required: form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口'],
                message: '请选择',
                type: 'number',
                trigger: 'change',
              }">
                <RadioGroup v-model.trim="form.childrenList[index].collectiveAccountMaterialsType">
                  <Radio :label="value" v-for="{text,value} in $store.state.collectiveAccountMaterialsTypeList" :key="value">{{text}}</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
              <Col span="12"
                v-show="form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">
              <FormItem :label="'上传子女' + (index + 1) + '户口簿详细地址页的首页'" :prop="'childrenList[' + index + '].residenceBookletMainPageGuid'"
                :rules="{ required: form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿']), message: '请上传', trigger: 'blur' }">
                <Row :gutter="16">
                  <Col span="24">
                  <div class="line_area">
                    <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,`childrenList${index}residenceBookletMainPageGuidProgress`)" :accept="accept"
                      :format="format" :show-upload-list="false" :data="uploadData" :on-success="
                        (response, file, fileList) =>
                         {$refs[`childrenList${index}residenceBookletMainPageGuidProgress`][0].updateShow(false)
        $refs['childrenList'+index+'residenceBookletMainPageGuidProgressUpload'][0].style.display = 'block'; handleSuccess(
                            response,
                            file,
                            fileList,
                            `childrenList[${index}].residenceBookletMainPageGuid`
                          )}
                      " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                      <div class="uploadBg">
                        <span :ref="'childrenList'+index+'residenceBookletMainPageGuidProgressUpload'">
                          <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                          <div class="upload_btn">
                            <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                          </div>
                          <div class="upload_btn" @click.stop="openQrCodeUpload( `childrenList[${index}].residenceBookletMainPageGuid`)">
                            <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                          </div>
                        </span>
                        <progress-bar :ref="'childrenList'+index+'residenceBookletMainPageGuidProgress'"></progress-bar>

                      </div>
                    </Upload>
                    <!-- 已上传图片 -->
                    <div class="fileList" v-if="
                        form.childrenList[index].residenceBookletMainPageGuid
                      ">
                      <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                      <span class="pos">
                        <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index]
                              .residenceBookletMainPageGuid
                          " />
                        <i class="img_magnify">
                          <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].residenceBookletMainPageGuid)" type="ios-eye" />
                          <Icon size="26" class="ico" color="#ffffff" @click="
                              handleRemove(
                                0,
                                form.childrenList[index]
                                  .residenceBookletMainPageGuid,
                                `childrenList[${index}].residenceBookletMainPageGuid`
                              )
                            " type="ios-trash-outline" />
                        </i>
                      </span>
                      <!-- </template> -->
                    </div>
                    <div class="fileList" v-else>
                      <span class="pos">
                        <span class="img">
                          <span class="uploadImageNo">
                            <Icon type="ios-image" size="30" />
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  </Col>
                </Row>
              </FormItem>
              </Col>
              <Col span="12"
                v-show="form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">
              <FormItem :label="'上传子女' + (index + 1) + '户口簿本人信息页'" :prop="'childrenList[' + index + '].residenceBookletSelfPageGuid'"
                :rules="{ required: form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿']), message: '请上传', trigger: 'blur' }">
                <Row :gutter="16">
                  <Col span="24">
                  <div class="line_area">
                    <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,`childrenList${index}residenceBookletSelfPageGuidProgress`)" :accept="accept"
                      :format="format" :show-upload-list="false" :data="uploadData" :on-success="
                        (response, file, fileList) =>
                         { $refs[`childrenList${index}residenceBookletSelfPageGuidProgress`][0].updateShow(false)
        $refs['childrenList'+index+'residenceBookletSelfPageGuidProgressUpload'][0].style.display = 'block';handleSuccess(
                            response,
                            file,
                            fileList,
                            `childrenList[${index}].residenceBookletSelfPageGuid`
                          )}
                      " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                      <div class="uploadBg">
                        <span :ref="'childrenList'+index+'residenceBookletSelfPageGuidProgressUpload'">
                          <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                          <div class="upload_btn">
                            <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                          </div>
                          <div class="upload_btn" @click.stop="openQrCodeUpload( `childrenList[${index}].residenceBookletSelfPageGuid`)">
                            <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                          </div>
                        </span>
                        <progress-bar :ref="'childrenList'+index+'residenceBookletSelfPageGuidProgress'"></progress-bar>

                      </div>
                    </Upload>
                    <!-- 已上传图片 -->
                    <div class="fileList" v-if="
                        form.childrenList[index].residenceBookletSelfPageGuid
                      ">
                      <span class="pos">
                        <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index]
                              .residenceBookletSelfPageGuid
                          " />
                        <i class="img_magnify">
                          <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].residenceBookletSelfPageGuid)" type="ios-eye" />
                          <Icon size="26" class="ico" color="#ffffff" @click="
                              handleRemove(
                                0,
                                form.childrenList[index]
                                  .residenceBookletSelfPageGuid,
                                `childrenList[${index}].residenceBookletSelfPageGuid`
                              )
                            " type="ios-trash-outline" />
                        </i>
                      </span>
                    </div>
                    <div class="fileList" v-else>
                      <span class="pos">
                        <span class="img">
                          <span class="uploadImageNo">
                            <Icon type="ios-image" size="30" />
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  </Col>
                </Row>
              </FormItem>
              </Col>
              <Col span="12"
                v-show="form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明']">
              <FormItem :label="'上传子女' + (index + 1) + '派出所出具的户籍证明'" :prop="'childrenList[' + index + '].policeStationRegistrationCertificateGuid'"
                :rules="{ required: form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明'], message: '请上传', trigger: 'blur' }">
                <Row :gutter="16">
                  <Col span="24">
                  <div class="line_area">
                    <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,`childrenList${index}policeStationRegistrationCertificateGuidProgress`)" :accept="accept"
                      :format="format" :show-upload-list="false" :data="uploadData" :on-success="
                        (response, file, fileList) =>
                         { $refs[`childrenList${index}policeStationRegistrationCertificateGuidProgress`][0].updateShow(false)
        $refs['childrenList'+index+'policeStationRegistrationCertificateGuidProgressUpload'][0].style.display = 'block';handleSuccess(
                            response,
                            file,
                            fileList,
                            `childrenList[${index}].policeStationRegistrationCertificateGuid`
                          )}
                      " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                      <div class="uploadBg">
                        <span :ref="'childrenList'+index+'policeStationRegistrationCertificateGuidProgressUpload'">
                          <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                          <div class="upload_btn">
                            <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                          </div>
                          <div class="upload_btn" @click.stop="openQrCodeUpload( `childrenList[${index}].policeStationRegistrationCertificateGuid`)">
                            <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                          </div>
                        </span>
                        <progress-bar :ref="'childrenList'+index+'policeStationRegistrationCertificateGuidProgress'"></progress-bar>

                      </div>
                    </Upload>
                    <!-- 已上传图片 -->
                    <div class="fileList" v-if="
                        form.childrenList[index].policeStationRegistrationCertificateGuid 
                      ">
                      <span class="pos">
                        <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index]
                              .policeStationRegistrationCertificateGuid 
                          " />
                        <i class="img_magnify">
                          <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].policeStationRegistrationCertificateGuid )" type="ios-eye" />
                          <Icon size="26" class="ico" color="#ffffff" @click="
                              handleRemove(
                                0,
                                form.childrenList[index]
                                  .policeStationRegistrationCertificateGuid ,
                                `childrenList[${index}].policeStationRegistrationCertificateGuid`
                              )
                            " type="ios-trash-outline" />
                        </i>
                      </span>
                    </div>
                    <div class="fileList" v-else>
                      <span class="pos">
                        <span class="img">
                          <span class="uploadImageNo">
                            <Icon type="ios-image" size="30" />
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  </Col>
                </Row>
              </FormItem>
              </Col>
              <Col span="24" v-show="form.childrenList[index].childType !=$store.state.childTypeEnum['领养']">
              <FormItem :label="'上传子女' + (index + 1) + '出生医学证明原件'" :prop="'childrenList[' + index + '].birthCertificateGuid'"
                :rules="{ required: form.childrenList[index].childType !=$store.state.childTypeEnum['领养'], message: '请上传', trigger: 'blur' }">
                <Row :gutter="16">
                  <Col span="24">
                  <div class="line_area">
                    <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,`childrenList${index}birthCertificateGuidProgress`)" :accept="accept" :format="format"
                      :show-upload-list="false" :data="uploadData" :on-success="
                        (response, file, fileList) =>
                         {$refs[`childrenList${index}birthCertificateGuidProgress`][0].updateShow(false)
        $refs['childrenList'+index+'birthCertificateGuidProgressUpload'][0].style.display = 'block'; handleSuccess(
                            response,
                            file,
                            fileList,
                            `childrenList[${index}].birthCertificateGuid`
                          )}
                      " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                      <div class="uploadBg">
                        <span :ref="'childrenList'+index+'birthCertificateGuidProgressUpload'">
                          <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                          <div class="upload_btn">
                            <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                          </div>
                          <div class="upload_btn" @click.stop="openQrCodeUpload( `childrenList[${index}].birthCertificateGuid`)">
                            <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                          </div>
                        </span>
                        <progress-bar :ref="'childrenList'+index+'birthCertificateGuidProgress'"></progress-bar>

                      </div>
                    </Upload>
                    <!-- 已上传图片 -->
                    <div class="fileList" v-if="form.childrenList[index].birthCertificateGuid">
                      <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                      <span class="pos">
                        <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index].birthCertificateGuid
                          " />
                        <i class="img_magnify">
                          <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].birthCertificateGuid)" type="ios-eye" />
                          <Icon size="26" class="ico" color="#ffffff" @click="
                              handleRemove(
                                0,
                                form.childrenList[index].birthCertificateGuid,
                                `childrenList[${index}].birthCertificateGuid`
                              )
                            " type="ios-trash-outline" />
                        </i>
                      </span>
                      <!-- </template> -->
                    </div>
                    <div class="fileList" v-else>
                      <span class="pos">
                        <span class="img">
                          <span class="uploadImageNo">
                            <Icon type="ios-image" size="30" />
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  </Col>
                </Row>
              </FormItem>
              </Col>
            </Row>
          </div>
        </template>
        <Button type="warning" style="margin-bottom:10px;" @click="addChild('childrenList')" icon="md-add">添加子女</Button>

      </template>
      <Col span="12">
      <FormItem label="注销申请人积分、配偶子女信息申请表" prop="logoutApplicationFormGuid">
        <Upload :show-upload-list="false" :before-upload='(file)=>handleBefore(`logoutApplicationFormGuid`)' :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :ref="'logoutApplicationFormGuid'"
          :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `logoutApplicationFormGuid`)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`logoutApplicationFormGuid`)" :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('logoutApplicationFormGuid')">手机拍照上传</Button>
        </Upload>

        <div>
          <a class="_link" :href="$baseURL + '/templates/注销申请人积分申请表.docx'">《注销申请人积分申请表》模板下载</a>
        </div>
        <div>
          <a class="_link" :href="$baseURL + '/templates/注销配偶子女信息申请表.docx'">《注销配偶子女信息申请表》模板下载</a>
        </div>
        <div class="_linkdel" v-for="file in form.logoutApplicationFormGuidPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'logoutApplicationFormGuid')" />
          </div>
        </div>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="其他材料" prop="otherFileGuidList">
        <Upload ref="otherFileGuidList" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :show-upload-list="false" :default-file-list="form.otherFileGuidListPreview" style="flex:1;" :on-preview="handlePreview"
          :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'otherFileGuidList',true)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'otherFileGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('otherFileGuidList',true)">手机拍照上传</Button>
        </Upload>
        <div class="_linkdel" v-for="file in form.otherFileGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'otherFileGuidList',true)" />
          </div>
        </div>
      </FormItem>
      </Col>
      <div class="bom_btn">
        <div>
          <Button @click="next(0)">上一步</Button>
          <!-- <Button type="warning" @click="submitStore()">暂存</Button> -->
          <Button type="primary" @click="submitAccept('cancelInformationform')">提交</Button>
        </div>
      </div>

    </Form>

  </div>
</template>
<script>
// import ChildInformation from './childInformation/index'
export default {
  props: { form: { type: Object } },
  components: {
    // ChildInformation
  },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      appInfoDataType: this.$store.state.appInfoDataType,
      uploadData: {},
      loading: false,
      rules: {
        applicantIDCardNo: [{ required: true, message: '请输入' }],
        isLogoutChildren: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                (this.form.isLogoutChildren !== null && this.form.isLogoutChildren !== false) ||
                (this.form.isLogoutSpouse !== null && this.form.isLogoutSpouse !== false)
              ) {
                callback()
              } else {
                callback(new Error('请选择'))
              }
            },
          },
        ],
        applicantPhone: [
          { required: true, message: '请输入', trigger: 'change' },
          {
            pattern: /^[0-9]+$/,
            message: '请输入正确的联系方式',
            trigger: 'change',
          },
        ],
        applicantName: [{ required: true, message: '请输入' }],
        applicantResidencePermitAddress: [{ required: true, message: '请输入' }],
        changeDomicileAddress: [{ required: true, message: '请输入' }],
        logoutObjectType: [{ required: true, message: '请选择', type: 'number' }],
        applicantIDCardFrontGuid: [{ required: true, message: '请上传' }],
        applicantIDCardBackGuid: [{ required: true, message: '请上传' }],
        applicantResidencePermitFrontGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        applicantResidencePermitBackGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],

        applicantResidencePermitExpiryDate: [
          {
            required: true,
            message: '请选择',
            type: 'date',
            trigger: 'change',
          },
        ],

        applicantRegisteredResidenceType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        applicantCollectiveAccountMaterialsType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        applicantResidenceBookletMainPageGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        applicantResidenceBookletSelfPageGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        applicantPoliceStationRegistrationCertificateGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        logoutApplicationFormGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        'spouse.name': [{ required: true, message: '请输入' }],
        'spouse.idCardNo': [{ required: true, message: '请输入' }],
        'spouse.idCardFrontGuid': [{ required: true, message: '请上传', trigger: 'change' }],
        'spouse.idCardBackGuid': [{ required: true, message: '请上传', trigger: 'change' }],
        'spouse.registeredResidenceType': [{ required: true, message: '请选择', type: 'number' }],
        'spouse.residenceBookletMainPageGuid': [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        'spouse.residenceBookletSelfPageGuid': [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        'spouse.marriageCertificateGuid': [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        'spouse.registeredResidenceType': [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        'spouse.policeStationRegistrationCertificateGuid': [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        'spouse.collectiveAccountMaterialsType': [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        collectiveAccountMaterialsType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        registeredResidenceType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        policeStationRegistrationCertificateGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        name: [{ required: true, message: '请输入' }],
        idCardNo: [{ required: true, message: '请输入' }],
        idCardFrontGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        idCardBackGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        registeredResidenceType: [{ required: true, message: '请选择', type: 'number' }],
        residenceBookletMainPageGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        residenceBookletSelfPageGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        marriageCertificateGuid: [{ required: true, message: '请上传', trigger: 'change' }],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
      uniPersonalList: [
        { name: '本人', value: 1 },
        { name: '配偶/子女', value: 0 },
      ],
    }
  },
  methods: {
    next(val) {
      this.$emit('next', val)
    },
    // 获取子女年龄
    async getChildAge(name, index) {
      this.$refs[name].validateField('childrenList[' + index + '].idCardNo', async (res) => {
        if (res) {
          return
        }
        this.$emit('getAgeByCardId', this.form.childrenList[index].idCardNo, index)
      })
    },
    async submitStore() {
      this.loading = true
      let params = {
        guid: '',
        enterpriseId: 0,
        enterpriseName: '',
        enterpriseCode: '',
        personnelId: 0,
        personnelName: '',
        personnelIDCardNo: '',
        personnelPhone: '',
        applicantName: '',
        applicantIDCardNo: '',
        applicantPhone: '',
        applicantIDCardFrontGuid: '',
        applicantIDCardBackGuid: '',
        applicantResidencePermitFrontGuid: '',
        applicantResidencePermitBackGuid: '',
        applicantResidencePermitExpiryDate: '',
        logoutObjectType: null,
        isLogoutSpouse: null,
        isLogoutChildren: null,
        logoutApplicationFormGuid: '',
        otherFileGuidList: [],
        applicantRegisteredResidenceType: '',
        applicantPoliceStationRegistrationCertificateGuid: [],
        applicantCollectiveAccountMaterialsType: '',
        spouse: {},
        childrenList: [],
        applicationId: '',
        idCardBackGuid: '',
        idCardFrontGuid: '',
        idCardNo: '',
        marriageCertificateGuid: '',
        name: '',
        collectiveAccountMaterialsType: '',
        registeredResidenceType: '',
        residenceBookletMainPageGuid: '',
        residenceBookletSelfPageGuid: '',
        id: '',
      }
      for (let key in params) {
        if (key in this.form) {
          params[key] = this.form[key]
        }
      }
      console.log('🚀 ~ submitStore ~  this.form:', this.form)

      params.spouse.applicationId = params.applicationId
      params.spouse.idCardBackGuid = params.idCardBackGuid
      params.spouse.idCardFrontGuid = params.idCardFrontGuid
      params.spouse.idCardNo = params.idCardNo
      params.spouse.marriageCertificateGuid = params.marriageCertificateGuid
      params.spouse.collectiveAccountMaterialsType = params.collectiveAccountMaterialsType
      params.spouse.name = params.name
      params.spouse.registeredResidenceType = params.registeredResidenceType
      params.spouse.residenceBookletMainPageGuid = params.residenceBookletMainPageGuid
      params.spouse.residenceBookletSelfPageGuid = params.residenceBookletSelfPageGuid
      params.spouse.id = params.id
      try {
        let data = await this.$Ajax.post(
          '/api/services/app/OtherApplicationApi/SaveLogoutApplicantPointsInfo',
          params
        )
        this.loading = false
        if (data.data.success) {
          this.$Message.success({
            content: '暂存成功',
            background: true,
            duration: 6,
          })
        }
      } catch (error) {
        this.loading = false
      }
    },
    //提交
    submitAccept(name) {
      console.log('🚀 ~ submitAccept ~ name:', name)

      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        //有提交路径才执行
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认提交申请？</p>',
          okText: '是',
          cancelText: '否',
          onOk: async () => {
            // 是 直接提交
            this.submit()
          },
          onCancel: () => {},
        })
      })
    },

    async submit() {
      this.loading = true
      let params = {
        guid: '',
        enterpriseId: 0,
        enterpriseName: '',
        enterpriseCode: '',
        personnelId: 0,
        personnelName: '',
        personnelIDCardNo: '',
        personnelPhone: '',
        applicantName: '',
        applicantIDCardNo: '',
        applicantPhone: '',
        applicantIDCardFrontGuid: '',
        applicantIDCardBackGuid: '',
        applicantResidencePermitFrontGuid: '',
        applicantResidencePermitBackGuid: '',
        applicantResidencePermitExpiryDate: '',
        logoutObjectType: null,
        isLogoutSpouse: null,
        isLogoutChildren: null,
        logoutApplicationFormGuid: '',
        otherFileGuidList: [],
        applicantRegisteredResidenceType: '',
        applicantPoliceStationRegistrationCertificateGuid: [],
        applicantCollectiveAccountMaterialsType: '',
        spouse: {},
        childrenList: [],
        applicationId: 0,
        idCardBackGuid: '',
        idCardFrontGuid: '',
        idCardNo: '',
        marriageCertificateGuid: '',
        name: '',
        collectiveAccountMaterialsType: '',
        registeredResidenceType: '',
        residenceBookletMainPageGuid: '',
        residenceBookletSelfPageGuid: '',
        applicantResidenceBookletMainPageGuid: '',
        applicantResidenceBookletSelfPageGuid: '',
        id: 0,
      }
      for (let key in params) {
        if (key in this.form) {
          params[key] = this.form[key]
        }
      }
      console.log('🚀 ~ submitStore ~  this.form:', this.form)

      params.spouse.applicationId = params.applicationId
      params.spouse.idCardBackGuid = params.idCardBackGuid
      params.spouse.idCardFrontGuid = params.idCardFrontGuid
      params.spouse.idCardNo = params.idCardNo
      params.spouse.marriageCertificateGuid = params.marriageCertificateGuid
      params.spouse.collectiveAccountMaterialsType = params.collectiveAccountMaterialsType
      params.spouse.name = params.name
      params.spouse.registeredResidenceType = params.registeredResidenceType
      params.spouse.residenceBookletMainPageGuid = params.residenceBookletMainPageGuid
      params.spouse.residenceBookletSelfPageGuid = params.residenceBookletSelfPageGuid
      params.spouse.id = params.id

      try {
        let data = await this.$Ajax.post(
          '/api/services/app/OtherApplicationApi/SaveLogoutApplicantPointsInfo',
          params
        )
        this.loading = false
        if (data.data.success) {
          this.$Message.success({
            content: '提交成功',
            background: true,
            duration: 6,
          })
        }

        this.$emit('setResult', data.data.result)
        this.next(100)
      } catch (error) {
        this.loading = false
      }
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadInfo,
        readIdInfoAfterToView
      )
      this.$refs['cancelInformationform'].validateField(property)
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件大小超出
    handleMaxSize(file) {
      this.$emit('handleMaxSize', file)
    },
    //
    updateProgress(event, file, fileList, name) {
      if (Array.isArray(this.$refs[name + 'Upload'])) {
        this.$refs[name + 'Upload'][0].style.display = 'none'

        this.$refs[name][0].updateShow(true)
        this.$refs[name][0].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

        this.$refs[name + 'Upload'][0].show = event.percent == 100
        return
      }
      this.$refs[name + 'Upload'].style.display = 'none'

      this.$refs[name].updateShow(true)
      this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

      this.$refs[name + 'Upload'].show = event.percent == 100
    },
    //上传前 用于单个上传清空上传列表
    handleBefore(property) {
      //不为数组时传一个删一个列表
      try {
        this.$refs[property][0].clearFiles()
      } catch (error) {}
    },
    addChild(property) {
      this.$emit('addChild', property)
    },
    delChild(property, index) {
      this.$emit('delChild', property, index)
    },
  },
}
</script>
